module.exports = __webpack_public_path__ + "static/teck_1-4f0c32c824cbf58657c68962e05889e5.jpg";